import { FC } from 'react';

import { Button } from '@/components/Button';
import { useCopyToClipboard } from '@/hooks';
import useDevice from '@/hooks/useDevice';

import styles from './Banners.module.sass';
import type { BannerType } from './Banners';

const BannerItem: FC<BannerType> = ({ width, height }) => {
  const [, copy] = useCopyToClipboard(true);
  const { isMobile } = useDevice();

  const src = `https://amlbot.com/b/${width}.${height}.png`;

  const embedCode = `<a href="https://amlbot.com" target="_blank"><img src="${src}" alt="AMLBot"></a>`;

  return (
    <div className={styles.item}>
      <div className={styles.title}>
        {width}x{height}
      </div>
      <div className={styles.body}>
        <div className={styles.preview}>
          <img src={src} alt="AMLBot" />
        </div>
        <div className={styles.fields}>
          <div className={styles.textarea}>
            <textarea value={embedCode} rows={2} onChange={() => {}} />
          </div>
          <div className={styles.actions}>
            <Button onClick={() => copy(embedCode)} fullwidth={isMobile}>
              Copy
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerItem;
